




























import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import { ProductTabFilterOptions, PageConfig } from "../../types";
import ProductTable from "../ProductTable.vue";
import SKUNameRenderer from "../TableRenderers/SKUNameRenderer.vue";
import AvailabilityRenderer from "../TableRenderers/AvailabilityRenderer.vue";
import TableActionRenderer from "../TableRenderers/TableActionRenderer.vue";
import OOSRequestModal from "./OOSRequest.vue";
import NameRenderer from "../TableRenderers/NameRenderer.vue";

export default Vue.extend({
  components: {
    ProductTable,
    OOSRequestModal
  },
  name: "manage-skus",
  data(): { [key: string]: any } {
    return {
      compModalElement: {
        isVisible: false,
        title: "",
        type: "",
        content: "",
        data: {}
      },
      searchedData: {},
      skuTabItems: ProductTabFilterOptions,
      activeTab: ProductTabFilterOptions[0],
      skuTable: {
        columns: [
          {
            name: "sku_name",
            display_name: "PRODUCT NAME",
            fixed: false,
            width: 40,
            headrenderer: null,
            cellrenderer: SKUNameRenderer
          },
          {
            name: "sku_code",
            display_name: "SKU CODE",
            sortable: false,
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: NameRenderer
          },
          {
            name: "availability",
            display_name: "AVAILABILITY",
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: AvailabilityRenderer
          },
          {
            name: "action",
            display_name: "",
            fixed: false,
            width: 20,
            headrenderer: null,
            cellrenderer: TableActionRenderer
          }
        ]
      }
    };
  },
  provide(): any {
    return {
      actionHandler: this.handleTableAction,
      modalDoneAction: this.modalDoneAction,
      activeTab: this.getActiveTab
    };
  },
  methods: {
    ...mapActions("appModule", [
      "searchInventorySKUs",
      "requestInventoryOOSItem"
    ]),
    tabClicked(eventData: { tabKey: string }): void {
      this.activeTab = this.skuTabItems.find((tabItem: { key: string }) => {
        return tabItem.key === eventData.tabKey;
      });
      this.updateRoute();
    },
    updateRoute() {
      const query = {
        product_code: this.searchedData.sku_code,
        status: this.activeTab.name,
        limit: this.skuTableData.pageConfig.limit,
        offset: this.skuTableData.pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      this.skuTableData.pageConfig.query = encodeQueryParams(query);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/inventory/" +
        this.$router.currentRoute.params.searchQuery +
        "/" +
        JSON.stringify({
          data: this.searchedData.name,
          sku_code: this.searchedData.sku_code,
          status: this.activeTab,
          pageConfig: this.skuTableData.pageConfig
        }) +
        "/skus";
      this.$router.push({
        path: routeLink
      });
    },
    getActiveTab() {
      return this.activeTab;
    },
    modalDoneAction() {
      const transformRequest = {
        sku_code: this.compModalElement.data.sku_code,
        created_by: this.compModalElement.data.designer.name,
        ec_id: this.selectedEc.name
      };
      this.handleWithDecorationAction(() => {
        return this.requestOOSItem(transformRequest);
      }, this.modalElement).then(() => {
        this.$store.dispatch("uiModule/addToast", {
          severity: "success",
          message:
            "Request for Out of Stock for " +
            this.compModalElement.data.sku_code +
            " placed successfully"
        });
        this.compModalElement.data.isVisible = false;
      });
    },
    requestOOSItem(request: {
      sku_code: string;
      created_by: string | number;
      ec_id: string | number;
    }) {
      return this.requestInventoryOOSItem(request);
    },
    onSKUSearch() {
      this.handleWithDecorationAction(() => {
        return this.searchSKU();
      }, this.modalElement).then(() => {});
    },
    searchSKU() {
      return this.searchInventorySKUs(this.skuTableData.pageConfig);
    },
    handleTableAction(actionType: string, data: any) {
      let finishEditUrl = "";
      switch (actionType) {
        case "request":
          //open modal for request
          this.compModalElement = Object.assign(this.compModalElement, {
            renderComponent: OOSRequestModal,
            data: {
              isVisible: true,
              title: "Request Sample",
              type: "request",
              name: data.sku_name.name,
              sku_code: data.sku_code,
              designer: {
                name: "",
                display_name: ""
              }
            }
          });
          break;
        case "rowselect":
          //route to product details
          this.$emit("updateRoute", { to: "samples", data: data });
          break;
        case "edit":
          this.$store.commit(
            "appModule/setSelectedInventoryFinish",
            data.finish_data
          );
          finishEditUrl =
            "/" +
            this.selectedEc.name +
            "/add/" +
            JSON.parse(this.$router.currentRoute.params.productQuery).sku_code +
            "/finishes/" +
            data.sku_code;
          this.$store.commit("appModule/resetBreadcrumb");
          this.$router.push({
            path: finishEditUrl
          });
          break;
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          this.skuTableData.pageConfig.offset =
            this.skuTableData.pageConfig.limit * (data - 1);
          this.skuTableData.pageConfig.page = data;
          this.updateRoute();
          break;
        case "setPageLength":
          this.skuTableData.pageConfig.limit = data;
          this.skuTableData.pageConfig.page = 1;
          this.skuTableData.pageConfig.offset = 0;
          this.updateRoute();
          break;
      }
    },
    handleWithDecorationAction(
      asyncFunc: (...args: any) => Promise<any>,
      modal: { isVisible: boolean; content: string; type: string }
    ) {
      modal.isVisible = true;
      modal.type = "loading";
      return asyncFunc
        .apply(arguments)
        .then(response => {
          modal.isVisible = false;
          return response;
        })
        .catch((err: { error: string }) => {
          modal.isVisible = false;
          this.$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: err.error
          });
          throw err;
        });
    },
    initManageSKUs() {
      const parsedJSONData = JSON.parse(
        this.$router.currentRoute.params.productQuery
      );
      this.$store.dispatch("appModule/updateBreadcrumb", {
        data: {
          name: "skus",
          display_name: parsedJSONData.data,
          href: "",
          routerLink: this.$router.currentRoute.path
        },
        router: this.$router
      });
      this.searchedData = {
        name: parsedJSONData.data,
        sku_code: parsedJSONData.sku_code
      };
      this.skuTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      this.activeTab = parsedJSONData.status
        ? parsedJSONData.status
        : this.skuTabItems[0];
      // this.onSKUSearch();
    }
  },
  computed: {
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      skuTableData: "inventorySkuDetails"
    }),
    ...mapState("uiModule", {
      modalElement: "modalElement"
    })
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      this.initManageSKUs();
      this.onSKUSearch();
    }
  },
  mounted() {
    this.initManageSKUs();
  }
});
